import { render, staticRenderFns } from "./FlussiDettagliModalViewComponent.vue?vue&type=template&id=6967864a"
import script from "./FlussiDettagliModalViewComponent.vue?vue&type=script&lang=js"
export * from "./FlussiDettagliModalViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports